export default {
  'Watermark': 'ウォーターマーク',
  'Add Watermark Selection': 'ウォーターマークの選択範囲を追加する',
}